import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import PropTypes from 'prop-types'
import axios from 'axios';
import ChampionshipsFilter from '../components/Championships/Filter';
import ChampionshipsList from '../components/Championships/List';

class Championships extends Component {
  constructor(props) {
    super(props);

    this.state = {
      term: '',
      results: [],
      initialResults: [],
    }

  }

  componentDidMount() {
    axios
      .get("/api/v1/events/upcomings.json", {
        headers: { "X-Requested-With": "XMLHttpRequest" }
      })
      .then(response =>
        this.setState({
          results: response.data.championships,
          initialResults: response.data.championships
        })
      )
      .catch(error => {
        console.log(error);
      });
  }

  filterResults(e) {
    let fieldValue = e.target.value;
    this.setState({ term: fieldValue });

    if (this.state.term.length >= 3) {
      axios
        .get("/api/v1/events/upcomings.json?name=" + fieldValue, {
          headers: { "X-Requested-With": "XMLHttpRequest" }
        })
        .then(response =>
          this.setState({ results: response.data.championships })
        )
        .catch(error => {
          console.log(error);
        });
    } else {
      this.setState({results: this.state.initialResults});
    }
  }

  render() {
    return(
      <div className='container'>
        <div className='row my-5 filters'>
          <div className='col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12'>
            <ChampionshipsFilter term={this.state.term} filterResults={this.filterResults.bind(this)} />
          </div>
        </div>

        <div className='row mb-5 events'>
          <ChampionshipsList results={this.state.results} />
        </div>
      </div>
    )
  }
}

Championships.propTypes = {
  initialResults: PropTypes.array,
  results: PropTypes.array,
  term: PropTypes.string,
}

document.addEventListener('DOMContentLoaded', () => {
  ReactDOM.render(<Championships />, document.querySelector('#championships'))
})
